import ReceiptsPage from '@/features/applications/[applicationId]/receipts/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/applications/$applicationId/receipts')({
  component: ReceiptsPage,
})
